
export default {
	name: 'PzImage',
	props: {
		src: {
			type: String,
			default: ''
		},
		altImg: {
			type: [String, Number]
		},
		errorText: {
			type: String,
			default: ''
		},
		lazy: {
			type: Boolean,
			default: false
		},
		width: {
			type: String,
			default: '32px'
		},
		height: {
			type: String,
			default: '32px'
		},
		srcList: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	methods: {
		clickHandler() {
			this.$emit('click')
		}
	}
}
